import { PermissionSet } from "features/staffLogin/types/PermissionSet";
import { getActiveLocation } from "features/location/selectors/getLocationLocale";
import { createSelector } from "reselect";

export const getLocationPermissions = createSelector(
    getActiveLocation,
    (location) => new PermissionSet(location ? location.authInfo.permissions : [])
);
